import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Avatar } from './crmUi'
import { getOnboarding, type Onboarding } from './crmApi'
import { DealOnboarding } from './DealOnboarding'

/**
 * STANDALONE ONBOARDING PAGE — /crm/onboardings/:id (Lee, 30 Sep 2026).
 * Staging pulls create standalone records (no CRM lead by design), so every
 * board card needs somewhere to open: this page renders the full staff
 * Onboarding tab for a record by its own id. Lead-linked records still open
 * inside the lead as before.
 */
export const CrmOnboardingPage: React.FC = () => {
  const { id = '' } = useParams()
  const navigate = useNavigate()
  const [ob, setOb] = useState<Onboarding | null>(null)
  const [err, setErr] = useState(false)
  useEffect(() => { getOnboarding(id).then(setOb).catch(() => setErr(true)) }, [id])

  if (err) return <p className="text-sm text-txt-tertiary p-6">This onboarding doesn't exist (or was removed).</p>

  const meta = ob?.stagingMeta || {}
  return (
    <div className="h-full flex flex-col bg-surface overflow-hidden">
      <div className="flex items-center gap-3.5 px-5 py-3.5 bg-surface border-b border-border shrink-0">
        <button
          onClick={() => navigate('/crm/onboardings')}
          title="Back to Onboardings"
          className="w-9 h-9 shrink-0 rounded-xl border border-border bg-surface flex items-center justify-center text-txt-secondary hover:text-txt-primary hover:bg-surface-hover"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round" className="w-[18px] h-[18px]"><path d="M15 18l-6-6 6-6" /></svg>
        </button>
        <Avatar name={ob?.companyName || '…'} size={40} logoUrl={meta.logo_url || undefined} />
        <div className="min-w-0">
          <p className="text-[18px] font-bold text-txt-primary leading-tight truncate">{ob?.companyName || 'Loading…'}</p>
          <p className="text-[12px] text-txt-tertiary truncate">
            {meta.contact?.name || meta.contact?.email || 'Staging company'}{meta.status ? ` · ${String(meta.status)}` : ''} · not linked to a CRM lead
          </p>
        </div>
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto p-5 bg-surface-secondary">
        <DealOnboarding onboardingId={id} dealName={ob?.companyName || ''} />
      </div>
    </div>
  )
}
